<template>
  <section class="section">
    <div class="tlCnt">
      <div class="tlItem" :class="{active: st === 1}">1</div>
      <div class="tlItem" :class="{active: st === 2}">2</div>
      <div class="tlItem" :class="{active: st === 3}">3</div>
      <div class="tlItem" :class="{active: st === 4}">4</div>
      <div class="tlItem" :class="{active: st === 5}">5</div>
    </div>
    <div class="pageLoading" v-if="loading"></div>
    <div class="formCnt" v-else>
      <div class="formHeader">
        <p class="st1" v-if="st === 1">Isi data di bawah ini untuk mengikuti<br />
          <b class="cyl">BodyKey Challenge #6</b></p>
        <div class="nunuLili mantul" v-if="st === 2">
          <img src="../assets/nunu-mantul.png">
        </div>
        <div v-if="st === 2">
          <h4>Terima Kasih Telah Mendaftar</h4>
          <p>Silahkan tunggu email konfirmasi untuk menyelesaikan pendaftaran kamu.</p>
        </div>
        <div class="nunuLili" v-if="st === 9">
          <img src="../assets/angakat-barbel.png">
        </div>
        <div v-if="st === 9">
          <h4>Challengen Your Limit</h4>
          <p>Challenge your limit adalah program dari nutrilite
            untuk para ABO/PP ikut serta dalam program 14 hari
            bodykeyy tapi dengan menggunakan visual dari nunu dan lili.</p>
          <p>Progress dalam 14 hari yang dilakukan oleh kamu akan
            ter-refleksian oleh karakter yang kamu buat di dalam website ini.</p>
          <p>Banyak games menarik yang bisa diikuti untuk mendapatkan
            poin dalam game yang bisa digunakan untuk membuka acheivement
            yang bisa dipakai untuk mengklaim hadiah-hadiah menarik untuk kamu.</p>
          <button class="btn primary block" v-on:click="register">Pilih Karakter Kamu</button>
        </div>
        <div v-if="st === 3">
          <h4>Pilih Karakter!</h4>
          <div v-if="selectedChar">
            <div class="charCnt selected">
              <div class="charItem">
                <div class="theChar nunu"></div>
                <h4>Nunu</h4>
                <p>Lorem ipsum dolor sit amet</p>
              </div>
            </div>
            <div class="fieldGroup">
              <input type="text" class="field" placeholder="Nama">
            </div>
            <button class="btn primary block" v-on:click="register">Berikutnya</button>
          </div>
          <div class="charCnt" v-else>
            <div class="charItem" v-on:click="selectChar('nunu')">
              <div class="theChar nunu"></div>
              <h4>Nunu</h4>
              <p>Lorem ipsum dolor sit amet</p>
            </div>
            <div class="charItem" v-on:click="selectChar('lili')">
              <div class="theChar lili"></div>
              <h4>Lili</h4>
              <p>Lorem ipsum dolor sit amet</p>
            </div>
          </div>
        </div>
        <div v-if="st === 4">
          <div class="charPreview">
            <div class="head"></div>
            <div class="face"></div>
            <div class="body"></div>
          </div>
          <div class="accCnt">
            <h5>Kepala</h5>
            <div class="theAcc">
              <div class="accItem"></div>
              <div class="accItem"></div>
              <div class="accItem disabled">
                Unlock at level 12
              </div>
              <div class="accItem disabled">
                Unlock at level 24
              </div>
              <div class="accItem disabled">
                Unlock at level 40
              </div>
            </div>
          </div>
          <div class="accCnt">
            <h5>Muka</h5>
            <div class="theAcc">
              <div class="accItem"></div>
              <div class="accItem"></div>
              <div class="accItem disabled">
                Unlock at level 8
              </div>
              <div class="accItem disabled">
                Unlock at level 17
              </div>
              <div class="accItem disabled">
                Unlock at level 32
              </div>
            </div>
          </div>
          <div class="accCnt">
            <h5>Badan</h5>
            <div class="theAcc">
              <div class="accItem"></div>
              <div class="accItem"></div>
              <div class="accItem disabled">
                Unlock at level 10
              </div>
              <div class="accItem disabled">
                Unlock at level 20
              </div>
              <div class="accItem disabled">
                Unlock at level 60
              </div>
            </div>
          </div>
          <button class="btn primary block" v-on:click="register">Simpan Karakter</button>
        </div>
        <div v-if="st === 5">
          <div class="charPreview">
            <div class="head"></div>
            <div class="face"></div>
            <div class="body"></div>
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Jenis kelamin">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Tanggal lahir">
          </div>
          <div class="fieldGroup divider"></div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Berat badan">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Tinggi badan">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="BMI">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Linggar pinggang">
          </div>
          <div class="fieldGroup divider"></div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Upload foto depan">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Upload foto belakang">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Upload foto samping">
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Upload video 360">
          </div>
          <button class="btn primary block" v-on:click="register">Mulai Bermain</button>
        </div>
      </div>
      <form v-on:submit.prevent="register" v-if="st === 1">
        <div class="aboCnt">
          Nomor ABO
          <span>{{aboNo}}</span>
        </div>
        <div :class="{fieldGroup: true, hasError: form.email.error}">
          <input type="email" class="field" placeholder="Email" v-model="form.email.model"
            v-on:input="fieldChanged('email')" name="username">
          <div class="fieldError" v-if="form.email.error">{{form.email.error}}</div>
        </div>
        <div :class="{fieldGroup: true, hasError: form.phone.error}">
          <input type="text" class="field" placeholder="No. Telp."
            v-model="form.phone.model" v-on:input="fieldChanged('phone')">
          <div class="fieldError" v-if="form.phone.error">{{form.phone.error}}</div>
        </div>
        <!--
        <div :class="{fieldGroup: true, hasError: form.username.error}">
          <input type="text" class="field" placeholder="Username"
            v-model="form.username.model" v-on:input="fieldChanged('username')">
          <div class="fieldError" v-if="form.username.error">{{form.username.error}}</div>
        </div>
        -->
        <div :class="{fieldGroup: true, hasError: form.password.error}">
          <div class="fieldCnt">
            <input :type="form.password.type" class="field" placeholder="Password"
              v-model="form.password.model" v-on:input="fieldChanged('password')">
            <div :class="{showPwd: true, show: form.password.type === 'text'}"
              v-on:click="form.password.type = (form.password.type === 'text')
              ? 'password' : 'text'"></div>
          </div>
          <div class="fieldError" v-if="form.password.error">{{form.password.error}}</div>
        </div>
        <div class="fieldGroup">
          <label class="ckCnt"
            v-on:click="form.tnc.model = !form.tnc.model; form.tnc.error = false">
            <div :class="{checkbox: true, checked: form.tnc.model, hasError: form.tnc.error}"></div>
            Dengan mengklik kotak ini kamu setuju
            dengan <a href="https://nutrilite.co.id/bodykey/mulai-sekarang/syarat-ketentuan-bodykey-challenge"
              target="_blank">Syarat dan Ketentuan</a>
            <div class="fieldError"
              v-if="form.tnc.error">Mohon centang syarat dan ketentuan.</div>
          </label>
        </div>
        <button class="btn primary block" :class="{btnLoading: formLoading}">
          <span>Daftar</span></button>
      </form>
    </div>
  </section>
</template>

<script>

export default {
  name: 'home',
  components: {},
  data() {
    return {
      st: 1,
      loading: true,
      aboNo: null,
      selectedChar: null,
      formLoading: false,
      session: null,
      form: {
        email: { model: '', error: null },
        phone: { model: '', error: null },
        username: { model: '', error: null },
        password: { model: '', error: null, type: 'password' },
        tnc: { model: false, error: null },
      },
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    selectChar(char) {
      this.selectedChar = char;
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
    register() {
      if (this.formLoading) return;
      const formData = {
        session: this.session,
        email: this.form.email.model,
        phone: this.form.phone.model,
        // username: this.form.username.model,
        password: this.form.password.model,
      };
      if (!formData.email || formData.email === '') {
        this.form.email.error = 'Mohon masukan alamat email kamu.';
        return;
      }
      if (!formData.phone || formData.phone === '') {
        this.form.phone.error = 'Mohon masukan No. Telp kamu.';
        return;
      }
      // if (!formData.username || formData.username === '') {
      //   this.form.username.error = 'Mohon masukan username.';
      //   return;
      // }
      if (!formData.password || formData.password === ''
        || formData.password.length < 8) {
        this.form.password.error = 'Password minimal 8 karakter.';
        return;
      }
      if (!this.form.tnc.model) {
        this.form.tnc.error = true;
        return;
      }
      this.formLoading = true;
      this.$http.post(this.$config.uri('user/register/complete'), formData).then((r) => {
        this.formLoading = false;
        if (r.data.status === 307) {
          this.form.email.error = r.data.message;
        } else if (r.data.status === 308) {
          this.form.phone.error = r.data.message;
        } else if (r.data.status === 309) {
          this.form.username.error = r.data.message;
        } else if (r.data.status === 200) {
          // this.st = 2;
          this.$session.set('bk6_id', r.data.user.id);
          this.$session.set('bk6_role', r.data.user.role);
          this.$session.set('bk6_name', r.data.user.name);
          this.$session.set('bk6_email', r.data.user.email);
          this.$session.set('bk6_avatar', r.data.user.avatar);
          this.$session.set('bk6_birthdate', r.data.user.birthdate);
          this.$session.set('bk6_finisherBk2', r.data.user.finisherBk2);

          this.$session.set('bk6_point', r.data.user.point);
          this.$session.set('bk6_character', r.data.user.character);

          this.$session.set('bk6_accTop', r.data.user.accTop);
          this.$session.set('bk6_accMid', r.data.user.accMid);
          this.$session.set('bk6_accBot', r.data.user.accBot);
          this.$session.set('bk6_bg', r.data.user.bg);
          this.$session.set('bk6_customBg', r.data.user.customBg);
          this.$session.set('bk6_finisher', r.data.user.finisher);

          this.$session.set('bk6_gender', r.data.user.gender);

          this.$session.set('bk6_bodyHeight', r.data.user.bodyHeight);
          this.$session.set('bk6_bodyWeight', r.data.user.bodyWeight);
          this.$session.set('bk6_waistSize', r.data.user.waistSize);

          this.$session.set('bk6_bmi', r.data.user.bmi);
          this.$session.set('bk6_bmiType', r.data.user.bmiType);
          this.$session.set('bk6_bmr', r.data.user.bmr);
          this.$session.set('bk6_tdee', r.data.user.tdee);
          this.$session.set('bk6_tdeeType', r.data.user.tdeeType);

          this.$session.set('bk6_tshirt_size', r.data.user.tshirtSize);

          this.$session.set('bk6_jwt', r.data.token);
          window.location.href = `${this.$config.appPath}user/avatar`;
        } else {
          const msg = (r.data.message) ? r.data.message : 'Internal server error, please try again later';
          this.form.email.error = msg;
        }
      });
    },
  },
  mounted() {
    this.session = this.$route.query.session;
    if (!this.session || this.session === '') {
      this.$router.push('/');
    }
    this.$http.post(this.$config.uri('user/abono/session'), {
      session: this.session,
    }).then((r) => {
      if (r.data.status === 200) {
        this.loading = false;
        this.aboNo = r.data.aboNo;
        return;
      }
      this.$router.push('/');
    });
  },
};
</script>

<style scoped lang="scss">
.section{
  padding: 40px 20px;
  display: flex;
  align-items: center;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 768px) {
    min-height: calc(100vh - 60px);
  }
}
.pageLoading{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  background-image: url(../assets/loading.svg);
  background-size: 54px auto;
  background-position: center;
  background-repeat: no-repeat;
}
.tlCnt{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 40px 0 26px;
  display: none;
  &:before{
    content: "";
    position: absolute;
    top: 14px; left: 10px; right: 10px;
    height: 6px; background-color: #faeba9;
    border: #cddd00 2px solid;
  }
  .tlItem{
    width: 36px;
    height: 36px;
    text-align: center;
    font-weight: bold;
    box-sizing: border-box;
    font-size: 24px;
    padding-top: 3px;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(../assets/circle-bg-inactive.png);
    color: #767676;
    z-index: 3;
    &.active{
      background-image: url(../assets/circle-bg.png);
      color: #fff;
    }
  }
}
.aboCnt{
  margin-bottom: 20px;
  // box-shadow: 2px 2px 4px rgba(0,0,0,.1);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
  padding: 10px 16px;
  font-size: 14px;
  color: #767676;
  border-radius: 7px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, .5);
  // background-color: #f1eeca;
  span{
    display: block;
    font-size: 20px;
    border-radius: 3px;
    font-weight: bold;
    color: #444;
  }
}
.fieldGroup.divider{
  height: 2px;
}
.charCnt{
  display: flex;
  justify-content: space-between;
  margin: 80px 0 0;
  .charItem{
    text-align: center;
    width: calc(50% - 10px);
    .theChar{
      height: 200px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.nunu{
        background-image: url(../assets/nunu-hi.png);
      }
      &.lili{
        background-image: url(../assets/lili-hi.png);
        height: 140px;
        margin: 36px 0 24px;
      }
    }
    h4{
      margin: 0;
      font-size: 18px;
    }
    p{
      margin: 0;
      font-size: 14px;
    }
  }
  &.selected{
    margin: 20px 0 20px;
    display: block;
    .charItem{
      width: auto;
      .theChar{
        margin-bottom: 20px;
        height: 280px;
        &.nunu{
          background-image: url(../assets/nunu-iddle.png);
        }
      }
      h4{
        font-size: 24px;
      }
      p{
        font-size: 16px;
      }
    }
  }
}
.ckCnt{
  padding-left: 34px;
  position: relative;
  display: block;
  font-size: 15px;
  font-weight: normal;
  text-transform: none;
  color: #444;
  .fieldError{
    margin: 4px 0 0;
  }
}
.checkbox{
  width: 16px; height: 16px;
  border: #999 2px solid;
  border-radius: 3px;
  position: absolute;
  left: 2px; top: 2px;
  &.checked{
    background-color: #78C90E;
    border-color: #78C90E;
    background-image: url(../assets/checked.png);
    background-size: 16px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  &.hasError{
    border-color: red;
  }
}
.charPreview{
  width: auto;
  height: 280px;
  background-image: url(../assets/nunu-iddle.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 30px auto;
}
.accCnt{
  margin: 0 0 26px;
  h5{
    margin: 0 7px 6px;
    text-align: left;
    font-size: 16px;
    color: #555;
  }
  .theAcc{
    display: flex;
    .accItem{
      width: 60px;
      height: 60px;
      background-color: #addc91;
      margin-right: 10px;
      border-radius: 12px;
      box-sizing: border-box;
      &.disabled{
        background-color: #ccc;
        color: #767676;
        font-size: 11px;
        padding-top: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }
}
.formHeader{
  text-align: center;
  .nunuLili{
    text-align: center;
    &.mantul{
      margin-bottom: 40px;
    }
    img{
      height: 260px;
    }
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 26px;
    margin: 0 0 10px;
  }
  p{
    font-size: 16px;
    margin-top: 0;
    b.cyl{
      display: inline-block;
      margin-top: 6px;
      color: #006519;
      font-size: 22px;
    }
  }
}
.loginLinkCnt{
  text-align: center;
}
.loginLink{
  font-size: 15px;
  padding: 6px 10px;
  display: inline-block;
  margin: 12px auto 0;
}
</style>
